<!-- Component-wise layout (like df-artifact) -->
<main class="about-theme" *ngIf="useComponents && vm">
  <div class="about-shell">
    <app-about-hero [hero]="vm.hero"></app-about-hero>
    <app-about-community-section *ngIf="vm.community" [section]="vm.community"></app-about-community-section>
    <app-about-walk-section *ngIf="vm.walkSection" [section]="vm.walkSection"></app-about-walk-section>
    <app-about-founder-section *ngIf="vm.founderSection" [section]="vm.founderSection"></app-about-founder-section>
    <app-about-cta-section *ngIf="vm.ctaSection" [section]="vm.ctaSection"></app-about-cta-section>
  </div>
</main>

<!-- Legacy: plain HTML content -->
<div class="about-page" *ngIf="!isLoading && !hasError && !useComponents && aboutContent">
  <div class="about-content" [innerHTML]="aboutContent"></div>
</div>

<div class="about-page about-loading" *ngIf="isLoading">
  <div class="container text-center py-5">
    <p>Loading...</p>
  </div>
</div>

<div class="about-page about-error" *ngIf="hasError">
  <div class="container text-center py-5">
    <h2>About Page</h2>
    <p>This page is not configured for this facility. Please add <code>aboutPage</code> with <code>sections</code>, <code>contentUrl</code>, or <code>content</code> to your config.</p>
    <a routerLink="/" class="btn btn-primary">Back to Home</a>
  </div>
</div>
